var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-radio-group",
    {
      staticClass: "exam-checkbox-radio-box",
      attrs: { disabled: _vm.readOnly },
      on: { change: _vm.handleCheck },
      model: {
        value: _vm.checkValue[_vm.subjects.examQuestionsId],
        callback: function ($$v) {
          _vm.$set(_vm.checkValue, _vm.subjects.examQuestionsId, $$v)
        },
        expression: "checkValue[subjects.examQuestionsId]",
      },
    },
    _vm._l(_vm.subjects.options, function (item) {
      return _c(
        "el-radio",
        {
          key: item.examQuestionsOptionsId,
          attrs: { label: item.examQuestionsOptionsId + "[-]" + item.name },
        },
        [
          _c("span", [
            _vm._v(" " + _vm._s(item.option) + "." + _vm._s(item.name)),
          ]),
          _c("i", {
            class: [
              "iconfont right-icon",
              _vm.previewStatus && _vm.readOnly && _vm.subjects.result
                ? _vm.subjects.result.indexOf(item.examQuestionsOptionsId) > -1
                  ? _vm.subjects.answer.indexOf(item.examQuestionsOptionsId) >
                    -1
                    ? "icon-icon_gou"
                    : "icon-icon_wrong"
                  : ""
                : "icon-icon_gou",
            ],
          }),
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }